import { render, staticRenderFns } from "./MerchantDelegationForm.vue?vue&type=template&id=ff315720&scoped=true"
import script from "./MerchantDelegationForm.vue?vue&type=script&lang=js"
export * from "./MerchantDelegationForm.vue?vue&type=script&lang=js"
import style0 from "./MerchantDelegationForm.vue?vue&type=style&index=0&id=ff315720&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff315720",
  null
  
)

export default component.exports